import styled from "@emotion/styled";
import { NavbarButton } from "./NavbarButton";
import { WavyHamburger, WavyHamburgerExpanded } from "components/Icons";
import { useEffect, useRef } from "react";
import { NavbarLinkItem } from "./NavbarLinkItem";
import { linkItems } from "../NavbarV2Desktop";
import { css } from "@emotion/react";
import { GlobalStore } from "store/global/GlobalStore";
import { Theme } from "styles/theme";
import { useHover } from "usehooks-ts";
import { Z_INDICES } from "config/consts";

interface NavbarLinksProps {
  closeProfileActions: () => void;
}

export const NavbarLinks = ({ closeProfileActions }: NavbarLinksProps) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const isHover = useHover(buttonRef);
  const theme = GlobalStore.useState(s => s.theme);

  useEffect(() => {
    if (isHover) {
      closeProfileActions();
    }
  }, [closeProfileActions, isHover]);

  return (
    <NavbarLinksContainer isHover={isHover} ref={buttonRef}>
      <div style={{ display: "flex" }}>
        <NavbarButton
          tokenAddress={{
            active: WavyHamburgerExpanded,
            default: WavyHamburger,
          }}
          text="More"
          css={getNavbarButtonCss(theme)}
          colors={{ default: theme.font.secondary.default, hover: theme.font.secondary.default }}
          isAdditionalHover={isHover}
        />
        <PopupContainer isHover={isHover}>
          {linkItems.map(item => (
            <NavbarLinkItem key={item.text} {...item} />
          ))}
        </PopupContainer>
      </div>
    </NavbarLinksContainer>
  );
};

// Sub-components

const NavbarLinksContainer = styled.div<{ isHover: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 200%;
  height: 70%;
  margin-top: 14px;
  color: ${props => props.theme.font.secondary.default};
  cursor: ${props => (props.isHover ? "pointer" : "default")};
`;

const PopupContainer = styled.div<{ isHover: boolean }>`
  display: ${props => (props.isHover ? "flex" : "none")};
  flex-direction: column;
  min-width: 250px;
  position: relative;
  right: 38px;
  padding: 8px;
  align-items: flex-start;
  border-radius: 20px;
  background: ${props => props.theme.surface.main.primary.hover};
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  opacity: 0.5;
  animation: slide 0.25s ease-in-out forwards;
  z-index: ${Z_INDICES.NAV_BAR};

  @keyframes slide {
    100% {
      top: 0;
      opacity: 1;
    }
  }
`;

// Helpers

export const getNavbarButtonCss = (theme: Theme) => css`
  pointer-events: none;
`;
